import { Routes } from '@angular/router';

import { RoleGuard } from '../../core/auth/role-guard';

export const andonRoutes: Routes = [
  {
    path: 'andon',
    title: 'Andon Administration',
    canActivate: [RoleGuard],
    data: {
      roles: ['SuperAdmin', 'Operations.Admin'],
    },
    children: [
      {
        path: 'administration/services',
        title: 'Services',
        loadComponent: () => import('./andon-services').then(module => module.ServiceListComponent),
      },
      {
        path: 'administration/services/:id',
        title: 'Service',
        loadComponent: () => import('./andon-services').then(module => module.ServiceFormComponent),
      },
      {
        path: 'administration/workstations',
        title: 'Workstations',
        loadComponent: () =>
          import('./workstations').then(module => module.WorkstationListComponent),
      },
      {
        path: 'administration/workstations/:id',
        title: 'Workstation',
        loadComponent: () =>
          import('./workstations').then(module => module.WorkstationFormComponent),
      },
      {
        path: 'administration/users',
        title: 'Users',
        loadComponent: () => import('./users').then(module => module.AndonUserListComponent),
      },
      {
        path: 'administration/users/:id',
        title: 'User',
        loadComponent: () => import('./users').then(module => module.AndonUserFormComponent),
      },
      {
        path: 'administration/dashboards',
        title: 'Dashboards',
        loadComponent: () => import('./dashboards').then(module => module.DashboardListComponent),
      },
      {
        path: 'administration/dashboards/:id',
        title: 'Dashboard',
        loadComponent: () => import('./dashboards').then(module => module.DashboardFormComponent),
      },
      {
        path: 'administration/locations',
        title: 'Locations',
        data: {
          editLocation: true,
        },
        loadComponent: () => import('./locations').then(module => module.LocationListComponent),
      },
      {
        path: 'administration/locations/:id',
        title: 'Location',
        loadComponent: () => import('./locations').then(module => module.LocationFormComponent),
      },
    ],
  },
  {
    path: 'andon',
    title: 'Andon',
    children: [
      {
        path: 'workstation',
        title: 'Workstation',
        canActivate: [RoleGuard],
        data: {
          roles: ['SuperAdmin', 'Operations.Admin', 'Operations.AndonWorkstation'],
        },
        loadComponent: () =>
          import('./workstations').then(module => module.WorkstationViewComponent),
      },
      {
        path: 'dashboard',
        title: 'Dashboard',
        canActivate: [RoleGuard],
        data: {
          roles: ['SuperAdmin', 'Operations.Admin', 'Operations.AndonDashboard'],
        },
        loadComponent: () => import('./dashboards').then(module => module.DashboardViewComponent),
      },
      {
        path: 'locations',
        title: 'Locations',
        canActivate: [RoleGuard],
        data: {
          roles: ['SuperAdmin', 'Operations.Admin', 'Operations.AndonLocation'],
          editLocation: false,
        },
        loadComponent: () => import('./locations').then(module => module.LocationListComponent),
      },
      {
        path: 'locations/:id',
        title: 'Location',
        canActivate: [RoleGuard],
        data: {
          roles: ['SuperAdmin', 'Operations.Admin', 'Operations.AndonLocation'],
        },
        loadComponent: () => import('./locations').then(module => module.LocationViewComponent),
      },
    ],
  },
];
